import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetTrialBalanceQuery } from "../../../services/Reports";
import {
  getTrialBalanceRequest,
  getTrialBalanceFailure,
  getTrialBalanceSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allTrialBalance,
    isLoading: trialBalanceLoading,
    isError: trialBalanceError,
  } = useGetTrialBalanceQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.trialBalancePageNo,
    pageSize: state.trialBalancePageSize,
    fromDate: new Date(state.trialBalanceFromDate).toLocaleDateString(),
    toDate: new Date(state.trialBalanceToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (trialBalanceLoading) {
      dispatch(getTrialBalanceRequest());
    }
    if (trialBalanceError) {
      dispatch(getTrialBalanceFailure(trialBalanceError));
    }
    if (allTrialBalance) {
      dispatch(
        getTrialBalanceSuccess({
          data: allTrialBalance.data.trialBalance[0].data || [],
          totalPages:
            allTrialBalance.data.trialBalance[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allTrialBalance,
    profileData,
    state.trialBalanceFromDate,
    state.trialBalanceToDate,
    state.trialBalancePageNo,
    state.trialBalancePageSize,
  ]);
  return <></>;
};
export default Content;
